export default {
  metadata: {
    version: '1.0.0',
    id: 'header-mobile-1.0.0',
    name: 'JDSHeaderMobile'
  },
  hierarchy: {
    container: [
      {
        'header-container': [
          {
            'left-container': [
              {
                'prefix-container': [
                  'prefix-jds_button',
                  {
                    'logo-container': ['logo-slot', 'logo-jds-text']
                  },
                  'prefix-slot',
                  'name-jds-text'
                ]
              }
            ]
          },
          {
            'right-container': [
              'jds_search_box',
              {
                'suffix-container': [
                  'search-jds_action_button',
                  {
                    'icon-links-container': ['icon-links-jds_button']
                  },
                  'avatar-slot'
                ]
              },
              'suffix-jds_action_button',
              'suffix-slot'
            ]
          }
        ]
      },
      'jds_search_results',
      'tabs-slot'
    ]
  },
  base: {
    container: {
      'min-width': '{h_0}',
      'flex-direction': '{h_1}'
    },
    'header-container': {
      'min-width': '{h_2}',
      width: '{h_3}',
      'background-color': '{h_4}',
      'flex-direction': '{h_5}',
      'justify-content': '{h_6}',
      'align-items': '{h_7}',
      'padding-left': '{h_43}',
      'padding-top': '{h_9}',
      'padding-right': '{h_44}',
      'padding-bottom': '{h_11}',
      height: '{h_13}'
    },
    'left-container': {
      'flex-direction': '{h_14}',
      'justify-content': '{h_15}',
      'align-items': '{h_16}',
      gap: '{h_46}'
    },
    'prefix-container': {
      'flex-direction': '{h_18}',
      'justify-content': '{h_19}',
      'align-items': '{h_20}',
      gap: '{h_21}'
    },
    'prefix-jds_button': {
      size: 'medium'
    },
    'logo-container': {
      'flex-direction': '{h_22}',
      'justify-content': '{h_23}',
      'align-items': '{h_24}',
      gap: '{h_25}'
    },
    jds_search_box: {
      prefix: 'ic_search',
      kind: 'header',
      flex: 1
    },
    'right-container': {
      'flex-direction': '{h_31}',
      'justify-content': '{h_32}',
      'align-items': '{h_33}',
      gap: '{h_47}',
      width: '{size.max}'
    },
    'suffix-container': {
      'flex-direction': '{h_35}',
      'justify-content': '{h_36}',
      'align-items': '{h_37}',
      gap: '{h_48}'
    },
    'suffix-jds_action_button': {
      hidden: true,
      icon: 'ic_close',
      size: 'medium'
    },
    'icon-links-container': {
      'flex-direction': '{h_39}',
      'justify-content': '{h_40}',
      'align-items': '{h_41}',
      gap: '{h_42}',
      hidden: false
    },
    'icon-links-jds_button': {
      size: 'medium'
    },
    'search-jds_action_button': {
      hidden: true,
      icon: 'ic_search',
      size: 'medium'
    },
    jds_search_results: {
      open: false,
      _maxWidth: 784
    },
    'logo-jds-text': {
      'font-family': '{text_91}',
      color: '{text_18}',
      'font-size': '{text_90}',
      'line-height': '{text_92}',
      'letter-spacing': '{text_93}',
      'font-weight': '{text_94}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    },
    'name-jds-text': {
      'font-family': '{text_132}',
      color: '{text_18}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    _variant: {
      active_search: {
        'prefix-slot': {
          hidden: true
        },
        'avatar-slot': {
          hidden: true
        },
        'suffix-jds_action_button': {
          hidden: false
        },
        jds_search_box: {
          prefix: 'ic_search',
          flex: 1
        },
        'left-container': {
          hidden: true
        },
        'icon-links-container': {
          hidden: true
        },
        'suffix-slot': {
          hidden: true
        },
        jds_search_results: {
          open: true
        },
        'prefix-jds_button': {
          hidden: true
        },
        'name-jds-text': {
          hidden: true
        },
        'logo-jds-text': {
          hidden: true
        }
      }
    },
    search: {
      false: {
        jds_search_box: {
          hidden: true
        },
        'search-jds_action_button': {
          hidden: true
        }
      }
    },
    _IsLinksEmpty: {
      true: {
        'icon-links-container': {
          hidden: true
        }
      }
    }
  },
  combination: [
    {
      true: {
        false: {
          jds_search_box: {
            hidden: true
          },
          'search-jds_action_button': {
            hidden: false
          }
        }
      }
    }
  ],
  combination_config: [['search', 'expandedSearch']],
  api: {
    config: {
      _variant: {
        values: ['default', 'active_search']
      },
      search: {
        values: [true, false]
      },
      expandedSearch: {
        values: [true, false]
      },
      searchActive: {
        values: [false, true]
      },
      _IsLinksEmpty: {
        values: [false, true]
      }
    },
    data: {
      'prefix-jds_button': {
        icon: {
          name: 'prefix',
          type: 'icon'
        }
      },
      'icon-links-container': {
        value: {
          type: 'list',
          name: 'icons',
          object: {
            icon: 'icon',
            onClick: 'event'
          }
        }
      },
      'icon-links-jds_button': {
        icon: {
          name: 'icons.icon',
          type: 'icon'
        }
      },
      jds_search_box: {
        label: {
          type: 'string',
          name: 'searchLabel'
        },
        suffix: {
          type: 'icon',
          name: 'searchSuffix',
          function: true
        },
        value: {
          type: 'string',
          name: 'query'
        },
        showBack: {
          type: 'boolean',
          name: 'searchShowBack'
        },
        focusRequester: {
          type: 'focusRequester',
          name: 'focusRequester',
          platform: 'android'
        },
        imeAction: {
          type: 'imeAction',
          name: 'imeAction',
          platform: 'android'
        }
      },
      jds_search_results: {
        offsetX: {
          type: 'number',
          name: '_offsetX'
        },
        offsetY: {
          type: 'number',
          name: '_offsetY'
        },
        results: {
          type: 'list',
          name: 'searchResults',
          object: {
            icon: 'icon',
            label: 'string'
          }
        },
        header: {
          type: 'string',
          name: 'searchResultHeader'
        },
        query: {
          type: 'string',
          name: 'query'
        },
        headerAction: {
          type: 'string',
          name: 'searchResultHeaderAction'
        }
      },
      'logo-jds-text': {
        value: {
          type: 'string',
          name: 'brandLabel'
        }
      },
      'name-jds-text': {
        value: {
          type: 'string',
          name: 'pageTitle'
        }
      }
    },
    children: {
      'avatar-slot': {
        name: 'avatar',
        accepts: ['jds_avatar', 'jds_link'],
        max: 1
      },
      'prefix-slot': {
        name: 'pageTitlePrefix',
        accepts: ['jds_avatar', 'jds_icon', 'jds_image'],
        max: 1
      },
      'tabs-slot': {
        name: 'tabs',
        accepts: ['jds_tab'],
        max: 1
      },
      'suffix-slot': {
        name: 'suffix',
        accepts: ['jds_text', 'jds_button', 'jds_link'],
        max: 1
      },
      'logo-slot': {
        name: 'logo',
        accepts: ['jds_icon', 'jds_image', 'jds_link'],
        max: 1
      }
    },
    events: {
      container: {
        '_searchActive.onSearchActiveChange': 'onSearchActiveChange'
      },
      'header-container': {
        onAppear: {
          name: '_onAppear',
          platform: 'ios'
        }
      },
      'logo-container': {
        onClick: 'logoOnClick'
      },
      'avatar-slot': {
        onClick: 'avatarOnClick'
      },
      'prefix-jds_button': {
        onClick: 'prefixOnClick'
      },
      'suffix-jds_action_button': {
        onClick: 'suffixOnClick'
      },
      jds_search_box: {
        onBlur: 'onSearchBlur',
        onFocus: 'onSearchFocus',
        onChange: 'onSearchChange',
        onSuffixClick: 'onSearchBoxSuffixClick',
        onBack: 'onSearchBoxPrefixClick'
      },
      'search-jds_action_button': {
        onClick: 'onSearchIconClick'
      },
      jds_search_results: {
        onHeaderActionClick: 'onSearchResultHeaderActionClick',
        onClick: 'onSearchResultClick'
      }
    },
    a11y: {
      'icon-links-container': {
        name: 'icons',
        repeating: {
          ariaLabel: 'iconLinkAriaLabel',
          ariaDescribedby: {
            name: 'iconLinkAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_search_results: {
        name: 'searchResults',
        repeating: {
          ariaLabel: 'searchResultAriaLabel',
          ariaDescribedby: {
            name: 'searchResultAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'icon-links-jds_button': {
        properties: {
          ariaLabel: 'icons.iconLinkAriaLabel',
          ariaDescribedby: 'icons.iconLinkAriaDescribedby'
        }
      },
      'prefix-jds_button': {
        properties: {
          ariaLabel: 'prefixAriaLabel',
          ariaDescribedby: {
            name: 'prefixAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'suffix-jds_action_button': {
        properties: {
          ariaLabel: 'suffixAriaLabel',
          ariaDescribedby: {
            name: 'suffixAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_search_box: {
        properties: {
          prefixAriaLabel: 'searchBoxPrefixAriaLabel',
          suffixAriaLabel: 'searchBoxSuffixAriaLabel',
          ariaLabel: 'searchAriaLabel'
        }
      },
      'search-jds_action_button': {
        properties: {
          ariaLabel: {
            name: 'searchButtonAriaLabel',
            prop: 'dynamicButtonText'
          },
          ariaDescribedby: {
            name: 'searchButtonAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
